<template>
  <Container>
    <h1>Composition de l'équipe {{team.name}}</h1>
    <label for="teamName">Nom de l'équipe</label>
    <input v-model="team.name" type="text" name="teamName" id="teamName" class="input-large" />
    <label for="teamColor">Couleur de l'équipe</label>
    <input v-model="team.color" type="color" name="teamColor" id="teamColor" class="input-large" />
    <div v-for="(player, index) in team.players">
      <label :for="'playerName' + index">Joueur chapeau {{player.hat}}</label>
      <input v-model="player.name" :name="'playerName' + index" :id="'playerName' + index" type="text" class="input-large" />
      <label :for="'playerPriority' + index">Joueur prioritaire</label>
      <input v-model="player.priority" :name="'playerPriority' + index" :id="'playerPriority' + index" type="checkbox" class="input-checkbox" />
    </div>
    <a class="round-button fixed-button" v-on:click="addPlayer()"><i class="material-icons">add</i></a>
    <a class="button" v-on:click="deleteLastPlayer()"><i class="material-icons">clear</i> Supprimer le dernier joueur</a>
    <a class="button next-button" v-on:click="updateTeam()"><i class="material-icons">save</i>Enregistrer</a>
    
  </Container>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Container from "@/components/Container.vue";


export default {
  name: "team",
  components: {
      Container
  },
  data: function(){
    return {
      team: null
    }
  },
  mounted() {
    this.team = this.$store.state.teams.filter(team => team.id === this.$route.params.id)[0];
  },
  methods: {
    updateTeam: function(){
      axios.post("/teams", this.team).then(response => {
        this.$router.push('/teams')
      });
    },
    addPlayer: function(){
      this.team.players.push({
        'name': '',
        'hat': this.team.players.length + 1,
        'wasReferee': 0,
        'priority': false
      });
    },
    deleteLastPlayer: function(){
      this.team.players.pop();
    }
  }
};
</script>

<style scoped>
  input{
    margin-bottom: 20px;
  }
  .next-button{
    margin-left: 20px;
  }
</style>